import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StatusPill } from '../../../../../models/shared/status-pill';

@Component({
  selector: 'app-status-pill-review-entry',
  templateUrl: './status-pill-review-entry.component.html',
  styleUrls: ['./status-pill-review-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusPillReviewEntryComponent {
  @Input() label: string = '';
  @Input() statusPill: StatusPill | null = null;
}
